import ApplicationController from "./application_controller"

export default class extends ApplicationController {
  // This controller can be used to trigger the focused-layout class on the body element
  // of the page on mount. We use this eg. in a Turbo Frame to ensure that any body classes
  // are propegated to the containing layout (eg. checkout when switching between tiers).

  static values = {
    inverted: Boolean
  }

  connect() {
    super.connect()

    this.body.classList.toggle("focused-inverted-layout", this.invertedValue)
  }

  get body() {
    return document.body
  }
}
